import { render, staticRenderFns } from "./CreatePackingWizard.vue?vue&type=template&id=c88190a0&scoped=true"
import script from "./CreatePackingWizard.vue?vue&type=script&lang=ts"
export * from "./CreatePackingWizard.vue?vue&type=script&lang=ts"
import style0 from "./CreatePackingWizard.vue?vue&type=style&index=0&id=c88190a0&prod&scoped=true&lang=scss"
import style1 from "./CreatePackingWizard.vue?vue&type=style&index=1&id=c88190a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88190a0",
  null
  
)

export default component.exports